import React, { Component } from 'react';
import { Grid, GridCell } from 'rmwc/Grid';
import { connect } from 'react-redux';
import {Button} from 'rmwc/Button';
import { Typography } from 'rmwc/Typography';
import { Link } from 'react-router-dom'
import { Card } from 'rmwc/Card';
import { TextField} from 'rmwc/TextField';
import * as api from '../../api/api';
import { Select } from 'rmwc/Select';
import StatusMessage from '../../util/StatusMessage'
import UserInternalResourceComponent from './UserInternalResourceComponent';
import UserExternalResourceComponent from './UserExternalResourceComponent';

class UserResourcePage extends Component{
	constructor(props) {
    	super(props)
    	this.state = {
    		data:{
    			levelId: '',
                levels: [],
    			competencyId: '',
                resourceDetails: [],
                levelIdForKey: ''
    		}
    	}
    }

    handleLevelsChange = (event) => {
        let data = Object.assign({}, this.state.data)
        data.levelId = event.target.value
        this.setState({data: data})
    }

    handleFetch = (e) => {
        e.preventDefault()
        let data = Object.assign({}, this.state.data)

        if ((this.state.data.levelId == '') && (this.state.data.trackId == '')){
            return this.setState({errorMsg: 'Please choose a Level and Track to fetch.'})
        }
        else if(this.state.data.levelId == ''){
            return this.setState({errorMsg: 'Please choose a Level.'})
        }
        else if(this.state.data.trackId == ''){
            return this.setState({errorMsg: 'Please choose a Track.'})
        }
        api.userRenderResources(this.props.user.accessToken, this.props.competencyId, this.state.data.levelId)
        .then((result) => {
            data.resourceDetails =  result.data
            data.levelIdForKey = this.state.data.levelId
            this.setState({data: data})
        })
        
    }

    handleFlowChartPageReturn = (e) => {
        this.props.handleFlowChartPageReturn(this.props.accessToken)
    }

    //return api.userRenderResources(this.props.user.accessToken, this.props.competencyId, this.props.levelId, this.props.trackId)
    //    .then((result) => {
    //        data.resourceDetails =  result.data
    //        this.setState({data: data})
    //    })

    componentDidMount() {
        let data = Object.assign({}, this.state.data)

        return api.getCertificationLevels(this.props.user.accessToken)
        .then((result) => {
            data.levels = result.certification_level
            var genLevel = {};
            genLevel["id"] = 0;
            genLevel["name"] = "General";
            data.levels.push(genLevel)
            this.setState({data: data})
        })
    }

    render () {
        let displayComponent
        let resourceComponent
        let handleFetch = this.handleFetch
        let levelIdForKey = parseInt(this.state.data.levelIdForKey)
        


        if (this.state.data.resourceDetails.length > 0) {
            resourceComponent = (
                <div>
                    {this.state.data.resourceDetails.map(function(resource){
                        if(resource.resource_type === 'external') {
                            let resourcekeytemp = parseInt(levelIdForKey)
                            let resourceKey = resource.id + '_E' + resourcekeytemp
                            return (
                            <div key={resourceKey}>
                                    <UserExternalResourceComponent resourceId = {resource.id}
                                        resourceName = {resource.resource_name}
                                        resourceLink = {resource.resource_link} 
                                        resourceAuthor = {resource.author} 
                                        resourceDesc = {resource.description} 
                                        resourceTestTrack = {resource.test_track_name}
                                        bookmarkFunction = {true}
                                        archiveFunction = {false} />
                            </div>
                            )
                        }
                        else if (resource.resource_type === 'internal') {
                            let resourcekeytemp = parseInt(levelIdForKey)
                            let resourceKey = resource.id + '_I' + resourcekeytemp
                            return (
                                <div key={resourceKey}>
                                    <UserInternalResourceComponent resourceId = {resource.id}
                                        resourceName = {resource.resource_name}
                                        resourceLink = {resource.resource_link} 
                                        resourceAuthor = {resource.author} 
                                        resourceDesc = {resource.description}
                                        resourceTestTrack = {resource.test_track_name}
                                        bookmarkFunction = {true}
                                        archiveFunction = {false} /> 
                                </div>
                            )
                        }
                    })}
                </div>
            )
        }
        else {
            resourceComponent = (
                <div>
                    <Typography use="subtitle2" align="left"> Select a Level to fetch the corresponding resources of {this.props.competencyName}.<br/> If the resources don't get displayed after fetching, probably the resources have not been uploaded for them. Please change the level and fetch again!</Typography>
                </div>
            )
        }

        displayComponent = (
            <div>
            <GridCell span="2">
                <Button raised style={{width: '10%'}} onClick={this.handleFlowChartPageReturn}>Back</Button>
            </GridCell>
            <br />
            <GridCell span="12">
                <Card style={{padding: '25px'}}>
                    <Typography use="headline6"> {this.props.competencyName} </Typography>
                </Card>
            </GridCell>
            <GridCell span="12">
                <Grid>
                    <GridCell span="9">
                        <Select
                            name="mcLevels"
                            onChange={this.handleLevelsChange}
                            value={this.state.data.levelId}
                            className="select-component"
                            placeholder="--Select Level--">
                            {this.state.data.levels.map(level => (
                                <option key={level.id} value={level.id} data-name={level.name}>
                                    {level.name}
                                </option>
                            ))}
                        </Select>
                    </GridCell>
                    <GridCell span="2">
                        <Button raised style={{ width: '100%' }} onClick= {((e) => handleFetch(e))}>Fetch</Button>
                    </GridCell>
                </Grid>
            </GridCell>
            </div>
        )
    	return (
    		<div>
                {displayComponent}
                <br />
                <GridCell span="11">
                    <Card style={{padding: '25px'}}>
                        {resourceComponent}
                    </Card>
                </GridCell>
            </div>
        )
    }
}

function mapStateToProps({user, admin}) {
  return {
    user,
    admin
  }
}

function mapDispatchToProps() {
  return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(UserResourcePage);


// WEBPACK FOOTER //
// ./src/views/roadmap/UserResourcePage.jsx